import styled from 'styled-components';

export const Container = styled.ul`
  list-style: none;
  padding-left: 0;
`;

export const Name = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
`;

export const Date = styled.span`
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  color: rgba(0, 0, 0, 0.4);
`;

export const ContentText = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.95);
`;

export const Agrupamento = styled.p`
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  opacity: 0.8;
`;

export const ContainerAnexo = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
`;

export const Attachments = styled.div`
  width: 231px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;

  cursor: pointer;
  transition: all 0.3s ease-out;

  &:hover {
    background: #188fff1a;
    border-color: #188fff99;
  }

  & div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    & div:first-of-type {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: #1d1c1d;
    }
    & div:last-of-type {
      font-size: 12px;
      line-height: 14px;
      color: #616061;
    }
  }

  .icon {
    font-size: 22px;
  }
`;
